import { render } from "./TransportationView.vue?vue&type=template&id=f6763f16"
import script from "./TransportationView.vue?vue&type=script&lang=js"
export * from "./TransportationView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Maraki(Lika)\\Desktop\\zowitech work\\seregela_frontend_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__